import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Update_To_MongoDB_By_ID_No_Alert(
  updateDoc,
  dbName,
  collctiontext,
  id,
  logout
) {
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Update_To_MongoDB_By_ID",
        {
          updateDoc: updateDoc,
          dbName: dbName,
          collctiontext: collctiontext,
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
            username: localStorage.getItem("Username"),
            activitylog: "Yes",
            aboutid: id,
          },
        }
      );
      console.log("Response Data: ", response);
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return;
      }
    } catch (error) {
      console.error("Error Posting data: ", error);
      window.alert(
        "Error Posting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  postData();
}
